/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global $ */
	
	__webpack_require__(13);
	__webpack_require__(9);
	
	$(function () {
	    // Typekit events
	    __webpack_require__(16);
	
	    // Header bar
	    // require('./lib/header')
	
	    // Loading creds etc
	    __webpack_require__(7);
	
	    // Loading creds etc
	    __webpack_require__(8);
	
	    // Responsive items
	    __webpack_require__(5);
	
	    // Slider
	    __webpack_require__(15);
	
	    // Intercom triggers
	    __webpack_require__(14);
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global window */
	
	var queryString = __webpack_require__(18);
	
	// Allow for testing of the new assets
	if (window.location.search === '?dev=1') {
	    window.localStorage.setItem('dev', 'true');
	} else if (window.location.search === '?dev=0') {
	    window.localStorage.setItem('dev', 'false');
	}
	
	var knownRoutes = ['beta', 'token', 'jumo/token', 'reset', 'password/reset'];
	
	var query = queryString.parse(window.location.search);
	
	var stage = (null) || 'production';
	var baseurl = ("https://api.namesandfaces.com/1") + '/public' || 'https://api.namesandfaces.com/1/public';
	
	// Basic routing
	var route = window.location.pathname.replace(/\.html$/, '') // For local work
	.replace(/^\//, '');
	
	if (knownRoutes.indexOf(route) === -1) {
	    route = 'index';
	}
	
	module.exports = {
	    stage: stage,
	    baseurl: baseurl,
	    route: route,
	    query: query,
	    dev: window.localStorage && window.localStorage.getItem('dev') === 'true'
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	/* global $ */
	
	module.exports = {
	    busy: false,
	
	    hideErrorMessage: function hideErrorMessage() {
	        $("#error").fadeOutCss();
	    },
	
	    hideSuccessMessage: function hideSuccessMessage() {
	        $("#success-popup").fadeOutCss();
	    },
	
	    hideMessages: function hideMessages() {
	        this.hideErrorMessage();
	        this.hideSuccessMessage();
	    },
	
	    showErrorMessage: function showErrorMessage(message) {
	        var applyErrorState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        if ($.isArray(message)) {
	            message = message.map(function (text) {
	                return $('<p>').html(text);
	            });
	        }
	
	        $("#error").children('div').html(message).siblings('button').one('click', this.hideErrorMessage).parent().fadeInCss();
	
	        if (applyErrorState) {
	            $('.form-control').addClass('has-error').one('keyup', function () {
	                $(this).removeClass('has-error');
	            });
	        }
	    },
	
	    showSuccessMessage: function showSuccessMessage(message) {
	        $("#success-popup").children('div').html(message).siblings('button').one('click', this.hideSuccessMessage).parent().fadeInCss();
	    },
	
	    showLoadingState: function showLoadingState() {
	        this.busy = true;
	
	        $('#submit, .submit').addClass('busy');
	    },
	
	    hideLoadingState: function hideLoadingState() {
	        this.busy = false;
	
	        $('#submit, .submit').removeClass('busy');
	    }
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global $ */
	
	var _require = __webpack_require__(5),
	    checkContentSize = _require.checkContentSize;
	
	var env = __webpack_require__(1);
	
	var assetKeys = ['hero_output', 'hero_output_mobile', 'step1_output', 'step1_output_mobile', 'step2_output', 'step2_output_mobile', 'step3_output', 'step3_output_mobile', 'step4_output', 'step4_output_mobile'];
	
	module.exports = function (data) {
	    var isNewApp = env.dev || data.activeAppVersion === 2;
	    var assets = data.assets;
	
	
	    $('body').addClass('app-version-' + (isNewApp ? 2 : 1));
	    $('title').text(data.name + ' | Names & Faces');
	
	    $('#content-wrap h1').append($('<img />').attr('src', data.logo.url).attr('alt', data.name).attr('title', data.name));
	
	    if (data.landerLogoHeight) {
	        $('#content-wrap h1').find('img').height(data.landerLogoHeight).css('max-height', 'none');
	    }
	
	    var mobileImageUrl = isNewApp && data.lander_image_new_r ? data.lander_image_new_r : data.lander_image;
	
	    $('.mobile-image-banner').css('background-image', 'url(' + mobileImageUrl + ')');
	
	    // Check for a complete set of assets for the features slider
	    var hasCompleteSet = true;
	    $.each(assetKeys, function (index, key) {
	        if (!assets[key]) {
	            hasCompleteSet = false;
	            return false;
	        }
	    });
	
	    if (hasCompleteSet) {
	        $.each(assetKeys, function (index, key) {
	            $('#' + key).attr('src', assets[key].url);
	        });
	
	        if (isNewApp) {
	            $('.mobile-image-banner').css('background-image', 'url(' + assets.hero_output_mobile.url + ')');
	        }
	
	        $(".features").removeClass('features-hidden');
	        $(".discover").css('display', 'inline-block');
	    }
	
	    $("#loading-div").fadeOut(400, function () {
	        $("#content-wrap, .features, footer").fadeInCss();
	
	        checkContentSize();
	    });
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global $ */
	
	var RGBA = __webpack_require__(6);
	var env = __webpack_require__(1);
	
	module.exports = function (data) {
	    var shadow = RGBA.fromHex(data.hex);
	    var isNewApp = env.dev || data.activeAppVersion === 2;
	    var assets = data.assets;
	
	
	    var landerUrl = void 0;
	
	    shadow.a = 0.5;
	
	    if (isNewApp) {
	        landerUrl = assets.hero_output ? assets.hero_output.url : data.lander_image_new;
	    } else {
	        landerUrl = data.lander_image;
	    }
	
	    /* eslint-disable max-len */
	    $('<style type=\'text/css\'>              \n            a.link-highlight {box-shadow: inset 0 -10px 0 ' + shadow + ';}            \n            a.link-highlight:hover {box-shadow: inset 0 -33px 0 ' + shadow + ';}\n            \n            .success-trouble a.link-highlight {box-shadow: inset 0 -7px 0 ' + shadow + ';}\n            .success-trouble a.link-highlight:hover {box-shadow: inset 0 -25px 0 ' + shadow + ';}\n            \n            @media (max-width: 1450px) {\n                .success-trouble a.link-highlight {box-shadow: inset 0 -6px 0 ' + shadow + ';}\n                .success-trouble a.link-highlight:hover {box-shadow: inset 0 -23px 0 ' + shadow + ';}\n            }\n    \n            .form-control:active, .form-control:focus {\n                border: 1px solid #' + data.hex + ';\n                box-shadow: 0px 0px 2px 0px ' + shadow + ';\n            }\n            \n            .content:after {\n                background-image: url(' + landerUrl + ')\n            }\n            \n            .slider .slider-header .active button {\n                color: #' + data.branding.primary + ';\n            }\n        </style>'
	    /* eslint-enable */
	    ).appendTo("head");
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	/* global $ window Modernizr */
	
	var $content = $('.content > div');
	var $window = $(window);
	
	var checkContentSize = function checkContentSize() {
	    if (Modernizr.mq('(max-width: 950px)') || $content.height() + 180 > $window.height()) {
	        $('body').addClass('mobile');
	
	        $window.off('resize.content-size');
	    }
	};
	
	var t = 0;
	
	$window.on('resize.content-size', function () {
	    window.clearTimeout(t);
	
	    t = window.setTimeout(checkContentSize, 100);
	});
	
	checkContentSize();
	
	module.exports = {
	    checkContentSize: checkContentSize
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RGBA = function () {
	    function RGBA(r, g, b) {
	        var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	        _classCallCheck(this, RGBA);
	
	        this.r = r;
	        this.g = g;
	        this.b = b;
	        this.a = a;
	    }
	
	    _createClass(RGBA, [{
	        key: "toString",
	        value: function toString() {
	            return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.a + ")";
	        }
	    }], [{
	        key: "fromHex",
	        value: function fromHex(hex) {
	            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	
	            return result ? new this(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)) : null;
	        }
	    }]);
	
	    return RGBA;
	}();
	
	module.exports = RGBA;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global Bugsnag */
	
	var env = __webpack_require__(1);
	
	if (typeof Bugsnag !== "undefined") {
	    Bugsnag.releaseStage = env.stage;
	    Bugsnag.notifyReleaseStages = ["production"];
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var env = __webpack_require__(1);
	
	switch (env.route) {
	    case 'index':
	        __webpack_require__(10);
	        break;
	
	    case 'beta':
	    case 'token':
	    case 'jumo/token':
	        __webpack_require__(12);
	        break;
	
	    case 'reset':
	    case 'password/reset':
	        __webpack_require__(11);
	        break;
	
	    default:
	        break;
	}

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	/* global $ window */
	
	$.fn.extend({
	    fadeInCss: function fadeInCss() {
	        var _this = this;
	
	        this.addClass('fade-1');
	
	        // Add the fade class once a repaint has occured
	        window.setTimeout(function () {
	            _this.addClass('fade-2');
	        }, 33);
	
	        return this;
	    },
	
	    fadeOutCss: function fadeOutCss() {
	        return this.removeClass('fade-1 fade-2');
	    },
	
	    animateCss: function animateCss(animationName) {
	        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
	
	        this.addClass('animated ' + animationName).one(animationEnd, function () {
	            $(this).removeClass('animated ' + animationName);
	        });
	
	        return this;
	    },
	
	    fixHeight: function fixHeight() {
	        return this.height(this.outerHeight(true));
	    },
	
	    hasAttr: function hasAttr(attr) {
	        return this.attr(attr) !== undefined;
	    }
	});

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global $ window Bugsnag */
	
	var slugMap = {
	    amvbddo: 'amvbbdo',
	    mhs: 'mhs-2016',
	    mhs2016: 'mhs-2016',
	    cowan: 'cowan-2016',
	    hilton: 'hilton-2016',
	    kingswood: 'kingswood-2016'
	};
	
	var env = __webpack_require__(1);
	var applyOrganisationBranding = __webpack_require__(4);
	var applyOrganisationAssets = __webpack_require__(3);
	var baseurl = env.baseurl,
	    stage = env.stage;
	
	
	var utils = __webpack_require__(2);
	
	var slug = void 0;
	
	if (stage === 'production') {
	    slug = window.location.pathname.replace('/', '').replace(/\./g, '').replace(/\//, '.');
	} else {
	    slug = window.location.hash ? window.location.hash.replace('#', '').replace(/\//, '.') : '';
	}
	
	// AMV fix
	if (slug && slugMap[slug]) {
	    slug = slugMap[slug];
	}
	
	// HTML Overwrite
	if ($('body').attr('data-slug')) {
	    slug = $('body').attr('data-slug');
	}
	
	// Add slug to body for custom styles
	$('body').addClass('org-' + (slug || 'generic'));
	
	// Scroll with the discover link
	$('.discover').animateAnchorScroll();
	
	// Get creds
	if (slug.length > 0) {
	    $.ajax({
	        method: 'GET',
	        url: baseurl + '/credentials/lander/' + slug,
	        dataType: 'json',
	        success: function success(data) {
	            if (data.success) {
	                slug = data.slug;
	
	                if (data.h2) {
	                    // Escape the content, and then replace Names & Faces with &nbsp; to prevent line breaks
	                    var titleText = $('<div/>').text(data.h2).html().replace(/names &amp; faces/i, 'Names&nbsp;&amp;&nbsp;Faces');
	
	                    $('#content-wrap h2').html(titleText);
	                }
	
	                $("#copy").append($('<p>').text(data.copy.join(' ')));
	
	                applyOrganisationAssets(data);
	                applyOrganisationBranding(data);
	            } else {
	                $("#loading-div").fadeOut(400, function () {
	                    $("#four-oh-four").fadeInCss();
	                });
	
	                Bugsnag.notify("Organisation Not Found: " + slug, "Not Found Error: " + slug);
	            }
	        },
	        error: function error(jqXHR, textStatus, errorThrown) {
	            $("#loading-div").fadeOut(400, function () {
	                $("#four-oh-four").fadeInCss();
	            });
	
	            Bugsnag.notifyException("OrganisationNotFound: " + textStatus + " " + slug, errorThrown);
	        }
	    });
	} else {
	    $("#loading-div").fadeOut(400, function () {
	        $(".token-reset").fadeInCss();
	    });
	}
	
	$('#org-lander-form').on('submit', function (e) {
	    e.preventDefault();
	
	    if (utils.busy) {
	        return;
	    }
	
	    utils.hideErrorMessage();
	
	    if (!$("#creds-terms").is(":checked")) {
	        utils.showErrorMessage("Please agree to the Names &amp; Faces User Terms and Conditions.");
	
	        return;
	    }
	
	    utils.showLoadingState();
	
	    $.ajax({
	        method: 'POST',
	        url: baseurl + '/credentials/lander/' + slug + '/getCredentials',
	        data: JSON.stringify({
	            email: $('#email').val().toLocaleLowerCase(),
	            user_terms: $("#creds-terms").is(":checked")
	        }),
	        dataType: 'json',
	        contentType: 'text/plain',
	        success: function success(data) {
	            if (!data || !data.success) {
	                utils.hideLoadingState();
	                utils.showErrorMessage(data.message || "We were unable to identify your email address. " + "Might we have another email address of yours on file? " + "If you don't win, please contact us on " + "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>");
	            } else {
	                $("#inputs").fadeOut(function () {
	                    $("#success").fadeIn(300);
	                });
	            }
	        },
	        error: function error() {
	            utils.hideLoadingState();
	            utils.showErrorMessage("We were unable to process your request. " + "Please try again, but if you don't win, please contact us on " + "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>");
	        }
	    });
	});
	
	$("#generic-lander").on('submit', function (e) {
	    e.preventDefault();
	
	    if (utils.busy) {
	        return;
	    }
	
	    utils.hideErrorMessage();
	
	    utils.showLoadingState();
	
	    $.ajax({
	        method: 'POST',
	        url: baseurl + '/credentials/generic/email',
	        data: JSON.stringify({
	            email: $('#generic-email').val().toLocaleLowerCase()
	        }),
	        dataType: 'json',
	        contentType: 'text/plain',
	        success: function success(data) {
	            if (data && data.success) {
	                $("#generic-lander").fixHeight();
	                $("#generic-inputs").fadeOut(function () {
	                    $("#generic-success").fadeIn(300);
	                });
	            } else {
	                utils.hideLoadingState();
	                utils.showErrorMessage(data.message || "We were unable to identify your email address. " + "Might we have another email address of yours on file? " + "If you don't win, please contact us on " + "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>.");
	            }
	        },
	
	        error: function error(jqXHR, textStatus, errorThrown) {
	            utils.hideLoadingState();
	
	            if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.length) {
	                return utils.showErrorMessage(jqXHR.responseJSON.errors[0].message);
	            }
	
	            return utils.showErrorMessage("We were unable to process your request. " + "Please try again, but if you don't win, please contact us on " + "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>");
	        }
	    });
	});
	
	if (env.query.err) {
	    switch (env.query.err) {
	        case 'claimed':
	            utils.showErrorMessage("That link has already been used - please enter your email address below to be sent another. " + "<br>If you don't win, please contact us on " + "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>", false);
	            break;
	        case 'expired':
	        default:
	            utils.showErrorMessage("That link has expired - please enter your email address below to be sent another. " + "<br>If you don't win, please contact us on " + "<a href=\"mailto:hello@namesandfaces.co\">hello@namesandfaces.co</a>", false);
	            break;
	    }
	}
	
	module.exports = {};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global $ Bugsnag */
	
	var env = __webpack_require__(1);
	var utils = __webpack_require__(2);
	var query = env.query,
	    baseurl = env.baseurl;
	
	
	var handleError = function handleError(userTitle, userMessage, errorText, error) {
	    var $404 = $('.four-oh-four');
	
	    $404.find('h2').text(userTitle);
	    $404.find('p').text(userMessage);
	
	    $("#loading-div").fadeOut(400, function () {
	        $404.fadeInCss();
	    });
	
	    Bugsnag.notifyException('TokenError: ' + errorText, error);
	};
	
	if (query.t) {
	    $.ajax({
	        method: 'GET',
	        url: baseurl + '/credentials/token/' + query.t,
	        dataType: 'json',
	        success: function success(data) {
	            if (data.user) {
	                if (data.expired) {
	                    return handleError("That token has expired", "The link we emailed you is only valid for 24 hours. " + "Please return to the credential lander and try again.", "ExpiredToken");
	                }
	
	                if (data.claimed) {
	                    return handleError("That token has already been used", "Your account password has already been set using this link.", "ClaimedToken");
	                }
	
	                $("#loading-div").fadeOut(400, function () {
	                    $(".password-reset").fadeInCss();
	                });
	            } else {
	                handleError("Something went wrong", "We could not connect to our servers, please double check your internet connection and try again.", "No Token Data");
	            }
	        },
	
	        error: function error(jqXHR, textStatus, errorThrown) {
	            if (jqXHR.status === 404) {
	                return handleError("Invalid token", "We could not find that token. Please ensure you copied the link emailed to you correctly.", textStatus, errorThrown);
	            }
	
	            handleError("Something went wrong", "We could not connect to our servers, please double check your internet connection and try again.", textStatus, errorThrown);
	        }
	    });
	
	    $("#password-reset-form").submit(function (e) {
	        e.preventDefault();
	
	        if (utils.busy) {
	            return;
	        }
	
	        var password = $("#password").val();
	
	        if (password.length === 0) {
	            return utils.showErrorMessage("Please enter a password");
	        }
	
	        utils.hideMessages();
	        utils.showLoadingState();
	
	        // Get the details relating to the token
	        $.ajax({
	            method: 'POST',
	            url: $('body').hasAttr('data-generic') ? baseurl + '/credentials/generic/token/' + query.t : baseurl + '/password/reset/' + query.t,
	            data: JSON.stringify({
	                password: password
	            }),
	            dataType: 'json',
	            contentType: 'text/plain',
	            success: function success(data) {
	                if (data.success) {
	                    if (data.email) {
	                        $("#reset-success-copy").text('You can now log into your Names & Faces app using ' + data.email + ' along with your newly created password.');
	                    }
	
	                    $(".password-reset").fadeOut(700, function () {
	                        $(".reset-success, footer").fadeInCss();
	                    });
	                } else {
	                    utils.hideLoadingState();
	
	                    return utils.showErrorMessage(data.errors && data.errors.length && data.errors[0].message || "There was an issue processing your request. " + "Please contact us at hello@namesandfaces.co.");
	                }
	            },
	
	            error: function error(jqXHR, textStatus, errorThrown) {
	                utils.hideLoadingState();
	
	                if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.length) {
	                    return utils.showErrorMessage(jqXHR.responseJSON.errors[0].message);
	                }
	
	                return utils.showErrorMessage("There was an issue processing your request. " + "Please contact us at hello@namesandfaces.co.");
	            }
	        });
	    });
	} else {
	    // Show base form
	    $("#loading-div").fadeOut(400, function () {
	        $(".password-send-email").fadeInCss();
	    });
	
	    $("#password-send-email-form").submit(function (e) {
	        e.preventDefault();
	
	        if (utils.busy) {
	            return;
	        }
	
	        var email = $("#email").val();
	
	        if (email.length === 0) {
	            return utils.showErrorMessage("Please enter an email address");
	        }
	
	        utils.hideMessages();
	        utils.showLoadingState();
	
	        // Get the details relating to the token
	        $.ajax({
	            method: 'POST',
	            url: baseurl + '/password/email',
	            data: JSON.stringify({
	                email: email
	            }),
	            dataType: 'json',
	            contentType: 'text/plain',
	            success: function success(data) {
	                if (data.success) {
	                    utils.showSuccessMessage("We’ve sent you an email with a link to reset your password ");
	                } else {
	                    return utils.showErrorMessage("There was an issue processing your request. " + "Please contact us at hello@namesandfaces.co.");
	                }
	            },
	
	            error: function error(jqXHR, textStatus, errorThrown) {
	                if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.length) {
	                    return utils.showErrorMessage(jqXHR.responseJSON.errors[0].message);
	                }
	
	                return utils.showErrorMessage("There was an issue processing your request. " + "Please contact us at hello@namesandfaces.co.");
	            },
	
	            complete: function complete() {
	                utils.hideLoadingState();
	            }
	        });
	    });
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global $ Bugsnag window */
	
	var env = __webpack_require__(1);
	var utils = __webpack_require__(2);
	var applyOrganisationBranding = __webpack_require__(4);
	var applyOrganisationAssets = __webpack_require__(3);
	var query = env.query,
	    baseurl = env.baseurl;
	
	
	var handleError = function handleError(userTitle, userMessage, errorText, error) {
	    var $404 = $('.four-oh-four');
	
	    $404.find('h2').text(userTitle);
	    $404.find('p').text(userMessage);
	
	    $("#loading-div").fadeOut(400, function () {
	        $404.fadeInCss();
	    });
	
	    Bugsnag.notifyException('TokenError: ' + errorText, error);
	};
	
	var buildOrgUrl = function buildOrgUrl(slug, errType) {
	    var _window$location = window.location,
	        protocol = _window$location.protocol,
	        host = _window$location.host;
	
	
	    return protocol + '//' + host + '/' + slug + '?err=' + errType;
	};
	
	// Get the details relating to the token
	$.ajax({
	    method: 'GET',
	    url: baseurl + '/credentials/token/' + query.t,
	    dataType: 'json',
	    success: function success(data) {
	        if (data.user) {
	            if (env.route === 'beta') {
	                data.organisation.activeAppVersion = 2;
	            }
	
	            if (data.expired) {
	                window.location = buildOrgUrl(data.organisation.slug, 'expired');
	
	                return;
	
	                // return handleError(
	                //     "That token has expired",
	                //     "The link we emailed you is only valid for 24 hours. " +
	                //     "Please return to the credential lander and try again.",
	                //     "ExpiredToken"
	                // )
	            }
	
	            if (data.claimed) {
	                window.location = buildOrgUrl(data.organisation.slug, 'claimed');
	
	                return;
	
	                // return handleError(
	                //     "That token has already been used",
	                //     "Your account password has already been set using this link.",
	                //     "ClaimedToken"
	                // )
	            }
	
	            $('#content-wrap h2').eq(0).html(data.user.first ? 'Hi ' + data.user.first + ', let\u2019s set a new password.' : 'Let’s set a new password.');
	
	            applyOrganisationAssets(data.organisation);
	            applyOrganisationBranding(data.organisation);
	        } else {
	            handleError("Something went wrong", "We could not connect to our servers, please double check your internet connection and try again.", "No Token Data");
	        }
	    },
	
	    error: function error(jqXHR, textStatus, errorThrown) {
	        if (jqXHR.status === 404) {
	            return handleError("Invalid token", "We could not find that token. Please ensure you copied the link emailed to you correctly.", textStatus, errorThrown);
	        }
	
	        handleError("Something went wrong", "We could not connect to our servers, please double check your internet connection and try again.", textStatus, errorThrown);
	    }
	});
	
	$('form').submit(function (event) {
	    event.preventDefault();
	
	    var password = $("#password").val();
	
	    if (password.length === 0) {
	        return utils.showErrorMessage("Please enter a password");
	    }
	
	    utils.showLoadingState();
	
	    // Get the details relating to the token
	    $.ajax({
	        method: 'POST',
	        url: baseurl + '/credentials/token/' + query.t,
	        data: JSON.stringify({
	            password: password,
	            beta: env.route === 'beta'
	        }),
	        dataType: 'json',
	        contentType: 'text/plain',
	        success: function success(data) {
	            if (data.success) {
	                if (data.email) {
	                    $("#step-2-copy").text('Log in using ' + data.email + ' and the password you\'ve just created.'); // eslint-disable-line
	                }
	
	                var $wrap = $("#content-wrap");
	                var $content = $wrap.children();
	                var $inner = $content.children();
	                var $footer = $('footer');
	                var $form = $inner.find('form');
	                var $h2 = $inner.find('h2').eq(0);
	
	                var offset = $inner.offset();
	
	                $content.addClass('hide-img');
	
	                $h2.fadeTo(275, 0);
	                $footer.fadeTo(275, 0);
	
	                $form.fadeTo(300, 0, function () {
	                    $content.css('paddingTop', offset.top);
	                    $("body").addClass('mobile');
	                    $form.hide();
	                    $h2.hide();
	
	                    $("#token-success-wrap").fadeInCss();
	
	                    $footer.fadeTo(300, 1);
	                });
	            } else {
	                return utils.showErrorMessage(data.errors && data.errors.length && data.errors[0].message || "There was an issue processing your request. " + "Please contact us at hello@namesandfaces.co.");
	            }
	        },
	
	        error: function error(jqXHR, textStatus, errorThrown) {
	            utils.hideLoadingState();
	
	            if (jqXHR.responseJSON && jqXHR.responseJSON.errors && jqXHR.responseJSON.errors.length) {
	                return utils.showErrorMessage(jqXHR.responseJSON.errors[0].message);
	            }
	
	            return utils.showErrorMessage("There was an issue processing your request. " + "Please contact us at hello@namesandfaces.co.");
	        }
	    });
	});

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	/* global $ */
	
	var $scroll = $('body, html');
	
	$.fn.extend({
	    animateAnchorScroll: function animateAnchorScroll() {
	        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        return this.each(function (index, element) {
	            var $element = $(element);
	            var $target = $($element.attr('href')).removeAttr('id');
	
	            if ($target.length === 0) {
	                return;
	            }
	
	            $element.click(function (event) {
	                if (event.ctrlKey || event.metaKey) {
	                    return;
	                }
	
	                event.preventDefault();
	
	                $scroll.animate({
	                    scrollTop: $target.offset().top - offset
	                });
	            });
	        });
	    }
	});

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	/* global $ Intercom */
	
	$('.trigger-intercom').on('click', function (e) {
	    e.preventDefault();
	
	    Intercom('show'); // eslint-disable-line new-cap
	});

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	/* global $ window Modernizr */
	
	$('.slider').each(function () {
	    var $slider = $(this);
	    var $header = $slider.find('.slider-header');
	    var $sWindow = $slider.find('.slider-window');
	    var $buttons = $header.find('button');
	    var $lis = $header.find('li');
	    var $items = $slider.find('.slider-item');
	    var $next = $slider.find('.slider-next');
	    var $prev = $slider.find('.slider-prev');
	    var $mobileDotsWrap = $('<div class="mobile-dots" />').appendTo($header);
	
	    $items.each(function () {
	        $mobileDotsWrap.append($("<span />"));
	    });
	
	    var $mobileDots = $mobileDotsWrap.children();
	
	    var busy = false;
	    var activeIndex = 0;
	    var timeout = 0;
	    var isMobile = false;
	
	    var slideTo = function slideTo(index) {
	        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        var fadeInClass = void 0;
	        var fadeOutClass = void 0;
	
	        if (activeIndex === index || busy) {
	            return;
	        }
	
	        busy = true;
	
	        $lis.removeClass('active').eq(index).addClass('active');
	
	        // Work out whether we need to go left or right
	        // 1 for next / going right (content moves left)
	        // -1 for previous / going left (content moves right)
	        if (direction === null) {
	            direction = index > activeIndex ? 1 : -1;
	        }
	
	        if (direction === 1) {
	            fadeInClass = 'fadeInRight';
	            fadeOutClass = 'fadeOutLeft';
	        } else {
	            fadeInClass = 'fadeInLeft';
	            fadeOutClass = 'fadeOutRight';
	        }
	
	        $items.eq(activeIndex).removeClass('fadeInRight fadeInLeft active').addClass(fadeOutClass);
	        $items.eq(index).removeClass('fadeOutRight fadeOutLeft').addClass(fadeInClass);
	
	        $mobileDots.eq(activeIndex).removeClass('active');
	        $mobileDots.eq(index).addClass('active');
	
	        activeIndex = index;
	
	        window.setTimeout(function () {
	            busy = false;
	        }, 400);
	    };
	
	    $buttons.each(function (buttonIndex, button) {
	        var $btn = $(button);
	
	        // Store the default text
	        $btn.data('text-desktop', $btn.text());
	
	        // Bind click
	        $btn.click(function () {
	            return slideTo(buttonIndex);
	        });
	    });
	
	    $next.click(function () {
	        slideTo(activeIndex + 1 >= $items.length ? 0 : activeIndex + 1, 1);
	    }).on('touchstart', function () {
	        return $next.addClass('touch');
	    }).on('touchend', function () {
	        return $next.removeClass('touch');
	    });
	
	    $prev.click(function () {
	        slideTo(activeIndex <= 0 ? $items.length - 1 : activeIndex - 1, -1);
	    }).on('touchstart', function () {
	        return $prev.addClass('touch');
	    }).on('touchend', function () {
	        return $prev.removeClass('touch');
	    });
	
	    $mobileDots.eq(0).addClass('active');
	
	    // Code made useless because the design team lead by Andrew was asked to change the spec by the owner of the company
	    $(window).on('resize', function () {
	        window.clearTimeout(timeout);
	
	        timeout = window.setTimeout(function () {
	            if (Modernizr.mq('(max-width: 1000px)')) {
	                if (!isMobile) {
	                    isMobile = true;
	
	                    // $buttons.each((btnIndex, button) => {
	                    //     $(button).text($(button).data('text-mobile'))
	                    // })
	
	                    $next.add($prev).detach().appendTo($header);
	                }
	            } else if (isMobile) {
	                isMobile = false;
	
	                // $buttons.each((btnIndex, button) => {
	                //     $(button).text($(button).data('text-desktop'))
	                // })
	
	                $next.add($prev).detach().appendTo($sWindow);
	            }
	        }, 150);
	    }).trigger('resize');
	});

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	/* global $ window */
	
	// Ensure that hidden fonts are shown if TK takes too long to load
	window.setTimeout(function () {
	    $('html').addClass('wf-delayed');
	}, 2000);

/***/ },
/* 17 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(19);
	var objectAssign = __webpack_require__(17);
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (ret[key] === undefined) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
		});
	
		return ret;
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true
		};
	
		opts = objectAssign(defaults, opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					if (val2 === null) {
						result.push(encode(key, opts));
					} else {
						result.push(encode(key, opts) + '=' + encode(val2, opts));
					}
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** build/js/main-compiled.js
 **/